module.exports = __webpack_public_path__ + "kudos_24.svg?2bb1837a89c407d0e322d8dfd55024e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_24.svg
// module id = 122
// module chunks = 0